/* eslint-disable @typescript-eslint/no-var-requires */
/**
 * @file
 * Locale Configuration
 * Used in library: vue-i18n
 *
 * This file controls the languages and currencies
 * See https://kazupon.github.io/vue-i18n/guide/started.html
 * This configuration will be set in @/app/Setup.ts
 */

import {I18nOptions} from 'vue-i18n'
import merge from 'lodash/merge'

import {Lang} from '@/enums/Lang'
import {Currency} from '@/enums/Currency'

const enUSMessages = require('../locale/en-US/lang.json')
const ptBRMessages = require('../locale/pt-BR/lang.json')

/**
 * Moment JS languages pack
 * Note: US English is already imported by default
 */

/**
 * VUE I18n Configuration
 */
export class I18nConfig implements I18nOptions {
  readonly locale = (process.env.VUE_APP_LANG as Lang) || Lang.EN_US
  readonly fallbackLocale = Lang.EN_US
  readonly currency = process.env.VUE_APP_CURRENCY! as Currency

  readonly messages = {
    [Lang.EN_US]: enUSMessages,
    [Lang.PT_BR]: merge({}, enUSMessages, ptBRMessages),
  }

  readonly messagesVeeValidate = {
    [Lang.EN_US]: require('vee-validate/dist/locale/en'),
    [Lang.PT_BR]: require('vee-validate/dist/locale/pt_BR'),
  }
}
